import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  base: '/',
  mode: 'history',
	routes: [
		{path: '/',component:()=>import("./pages/login.vue"),name:"首页"},
		// {path: '/main',component:()=>import("./pages/main.vue"),name:"首页"},
		// {path: '/slide',component:()=>import("./pages/slide.vue"),name:"年报"},
		{path: '/slide',component:()=>import("./pages/slide2025.vue"),name:"年报"}
	]
})





